const login = {
  root: "Connexion",
  sign_in_here: "Connectez-vous ici",
  welcome: "Bienvenue sur la plateforme",
};
export default login;
